import React from 'react';
import {RowType} from "../../models/api/codegen/code";
import {CardBody} from './CardBody';

export const Columns: React.FC<{ row: RowType }> = ({row}) => {

    return (
        <div className="flex justify-between bg-[#171A1E] rounded-[8px] pt-[8px] pb-[8px] pl-[12px] mb-[8px]">
            {row.cards && row.cards.map((card, i) => (
                <div key={i}>
                    <CardBody card={card}/>
                </div>
            ))}
        </div>
    )
}
